import React, { useRef, useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const PDF = (props) => {

  const [pageNumber, setPageNumber] = useState(1);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setPdfPages(numPages);
  }

  const buildPreviews = () => {
    let assetId = window.elvisContext.activeTab.originalAssetSelection[0].metadata.id
    let numberOfPages = window.elvisContext.activeTab.originalAssetSelection[0].metadata.numberOfPages

    let previewsArray = []

    for (var i = 0; i < numberOfPages; i++) {

      let pdfPagePreviewLink = `${window.assetsPluginContext._context.activeTab.originalAssetSelection[0].previewUrl.split(assetId)[0]}${assetId}/previews/maxWidth_700_maxHeight_700_page_${i}.jpg?requestSecret=${window.requestSecret}`
      previewsArray.push(
        <a href={`${window.assetsPluginContext._context.activeTab.originalAssetSelection[0].previewUrl.split(assetId)[0]}${assetId}/previews/maxWidth_800_maxHeight_800_page_${i}.jpg?requestSecret=${window.requestSecret}`} target="_blank">
          <LazyLoadImage
            className="pdf-page"
            height={699}
            src={window.previewWithSecret.replace(/(page_)\w+/g, `page_${i}`) } // use normal <img> attributes as props
            width={400} />
        </a>


      )

    }




    return previewsArray

  }
  const [pdfPages, setPdfPages] = useState(buildPreviews);
  return (

    <div className="ems_content_workspace">
      <div className="ems_visual-wrapper">
        <div style={{ width: "80%" }}>
          {pdfPages}
        </div>

        {/* <img src={window.assetsPluginContext._context.activeTab.originalAssetSelection[0].previewUrl}/> */}

      </div>


    </div>
  );
};

export default PDF;